var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat1WHair2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair2_6_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M551.2,99.6c-1.9-4-3.9-7.8-6.1-11.6c-10-16.9-23.4-31.7-38.8-44.1C412.7-11.7,305.2-7.3,215.5,54.5 c-28.8,19.9-55.2,46.4-74.6,74.2c-24.6,45.5-26.9,111,14.7,147.2c1.7,1.2,3.4,2.4,5.3,3.4c4.9,1.5,8.8,2.3,10.9,2.8 c10.1,2.5,23.6,2.9,33.3-0.3c-0.1,0-0.2,0-0.4-0.1c7.2-3.6,9.4-15.4,11.9-23.4c8.1-20.1,4.3-52.2,11.1-61.2 c13.8-18.3,111.3-10,132-7.3l54,2.7c-1-3.5,60.4,5.9,61.3,6.7c20,18,38.7,66,19.3,96.7c11.2-6.6,24.7-17.9,38.8-30.5 c5.8-6.9,10.8-14.3,14.9-22.1c2.3-4.4,4.4-8.8,6.2-13.4C570.5,188.5,567.5,140.5,551.2,99.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat1_2_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M499.8,194l-0.8-17.3c-1.2-15.8-0.6-18.6-7.1-20.9c-1.2-0.4-2.5-0.8-3.7-1.3 c-18.5-6.2-37.8-10.7-57.4-13.7c-3.5-0.5-7-1-10.5-1.5c-28.7-4.8-58.2-7.1-88-6.1c-3.7,0.1-7.5,0.3-11.2,0.5 c-32.5,2.2-64.6,7.7-94.1,19.2c-1.4,0.5-2.7,1.1-4.1,1.6c-3,1.2-10.7-0.1-4.8,48.4l0.1,3.5c1.4,9.6,6,11.4,10.7,9.8 c0.4-0.1,0.7-0.2,1.1-0.4c2-0.7,4-1.3,6-1.9c14.6-4.2,29.5-7.4,44.6-9.7c7.6-1.2,15.2-2.1,22.9-2.8c36.1-3,72.1-3,107.4,0.6 c7.1,0.7,14.1,1.5,21.1,2.6c13.7,2.1,27.3,4.9,40.5,8.5C486.1,216.9,501.5,224.3,499.8,194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M332.2,133.3c29.8-1,59.3,1.3,88,6.1c3.5,0.5,7,0.9,10.5,1.5c19.6,3,38.9,7.5,57.4,13.7 c0.1-2.6,0.2-5.3,0.1-7.9c-0.1-3.4-0.3-6.7-0.8-10c-3-24.3-14.7-49.7-35.3-67.1c-2.9-2.5-6.1-4.8-9.4-6.9 C425.2,50.9,404,46.2,382.2,45c-3.6-0.2-7.3-0.3-11-0.3c-38.8,0.4-81.6,4.4-110.6,28.9c-3.1,2.4-5.9,5-8.5,7.6 c-19.2,19.6-26.5,45.9-25.3,71.9c29.5-11.4,61.6-17,94.1-19.2C324.7,133.6,328.5,133.4,332.2,133.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M483.4,149.9c-2.5-1-5.1-2.1-7.7-3.1c-17.1-6.6-35-11.9-53.3-15.9c-3.7-0.8-7.3-1.6-11-2.3 c-40.6-7.9-82.3-8.9-123.3-4.3c-3.7,0.4-7.4,0.9-11.1,1.5c-7.3,1.2-14.5,2.7-21.5,4.7C259,99,278.3,69,308.1,51.1 c0.2-0.1,0.3-0.2,0.5-0.3c-17.8,4.2-34.4,11.2-48,22.7c-3.1,2.4-5.9,5-8.5,7.6c-19.2,19.6-26.5,45.9-25.3,71.9 c29.5-11.4,61.6-17,94.1-19.2c3.7-0.2,7.5-0.4,11.2-0.5c29.8-1,59.3,1.3,88,6.1c3.5,0.5,7,0.9,10.5,1.5c19.6,3,38.9,7.5,57.4,13.7 c0-0.8,0.1-1.7,0.1-2.5C486.6,151.3,485,150.6,483.4,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M246.2,191.7c6.8-14.6,14.7-29.8,8.2-47.6c-9.4,2.5-18.6,5.4-27.6,8.9c-1.4,0.5-2.7,1.1-4.1,1.6 c-3,1.2-10.7-0.1-4.8,48.4l0.1,3.5c1.4,9.6,6,11.4,10.7,9.8c0.4-0.1,0.7-0.2,1.1-0.4c2-0.7,4-1.3,6-1.9c4.9-1.4,9.9-2.7,14.9-3.9 C247.9,204,244.1,197.3,246.2,191.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M361.5,34c-11.9-6.5-25.8,1.7-28.1,12.6c11.4-1.3,23-1.8,34.2-2C366.9,40.6,365.8,36.2,361.5,34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M320.2,137.1c3.7-0.2,7.5-0.4,11.2-0.5c29.8-1,59.3,1.3,88,6.1c3.5,0.5,7,0.9,10.5,1.5 c23.3,3.5,46,9.2,67.6,17.3c-0.8-3.2-2.3-4.5-5.7-5.7c-1.2-0.4-2.5-0.8-3.7-1.3c-6.8-2.3-13.7-4.3-20.7-6.2l-0.3-7.3 c-3.8-31.9-16.6-58.8-41.4-81.6c24.6,23.1,35.1,50.5,38.7,81.7l0.3,6.4c-11.1-2.8-22.3-5.1-33.7-6.8l-0.7-6.7 c-4.3-30.4-14.7-55.5-31.8-81.3c16.8,26.1,24.9,51.6,29,81.6l0.7,6.1c-2.6-0.4-5.2-0.7-7.9-1.1c-10-1.7-20-3-30.2-4.1l-0.3-6.3 c-1.7-28-3.4-52.3-13.7-78.4c10,26.3,9.4,50.6,11,78.5l0.3,5.9c-10.4-1-21-1.6-31.5-1.9v-6c-0.2-26.9-2.6-49.7-6.9-75.6 c3.9,26,4.1,48.9,4.2,75.6v5.9c-6.9-0.1-13.8-0.1-20.8,0.2c-3.7,0.1-7.5,0.3-11.2,0.5c-1.4,0.1-2.9,0.2-4.3,0.3l-0.5-5.4 c-1.9-26.6-2.1-50.1,9-74.8c-11.5,24.5-13.5,48.1-11.7,75c0.1,1.9,0.3,3.7,0.5,5.5c-11.5,1-22.9,2.4-34.1,4.3 c-0.3-1.7-0.7-3.4-0.9-5.2c-2.7-24.8,0.8-46.9,11.4-69.9c-10.9,22.8-16.7,44.6-14.1,70.1c0.2,1.8,0.6,3.6,0.9,5.4 c-7.7,1.4-15.2,3-22.7,5c-0.2-1.5-0.5-3.1-0.6-4.6c-1.7-22.9,2.4-42.7,10.3-64.3c-8.3,21.4-14.7,40.9-13.1,64.5 c0.1,1.8,0.4,3.5,0.6,5.2c-8.5,2.3-16.8,5-24.9,8.1c-1.4,0.5-2.7,1.1-4.1,1.6c-1.4,0.6-3.8,0.6-5.4,5.3c3.2-1.4,6.4-2.7,9.7-4 C256.3,144.8,288.1,139.3,320.2,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M411.2,198.1c-35.4-3.6-71.3-3.6-107.4-0.6c-7.7,0.7-15.3,1.7-22.9,2.8c-15.1,2.3-30,5.5-44.6,9.7 c-2.4,0.7-4.7,1.4-7.1,2.2c-2.5,0.9-5.1,1.8-7.5,2.8c2,1.9,4.6,2.1,7.2,1.2c0.4-0.1,0.7-0.2,1.1-0.4c2-0.7,4-1.3,6-1.9 c14.6-4.2,29.5-7.4,44.6-9.7c7.6-1.2,15.2-2.1,22.9-2.8c36.1-3,72.1-3,107.4,0.6c7.1,0.7,14.1,1.5,21.1,2.6 c13.7,2.1,27.3,4.9,40.5,8.5c7.6,2.1,15.8,5.3,21.2,2.5c-19.7-6.9-40.3-11.8-61.3-15C425.3,199.6,418.2,198.8,411.2,198.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M245.7,204.7c-7.1-16.6-5.8-31.8-4.9-48.4c-0.4,16.7,1.7,31.5,8.7,47.1l2,4.1l-3.6,1.5L245.7,204.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M271.9,199.1c-5.7-17-6.8-32.2-4.4-49.1c-1.8,17,2.6,31.8,8.2,48c0.5,1.5,1.2,2.9,1.8,4.3l-3.7,1.3 C273.1,202.1,272.4,200.7,271.9,199.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M302.2,195.1c-4.1-17.3-5.7-32.4-4.9-49.6c-0.1,17.2,4.7,31.8,8.9,48.8l1.2,4.6l-3.9,0.8L302.2,195.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M335.2,192.9c-3.4-17.8-1.5-33.1,1.1-50.2c-2,17.2-0.6,32.4,2.9,49.5l1,4.6l-3.9,0.7L335.2,192.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M369.5,192.4c2.9-17.6,5.3-32.8,3.3-50.3c2.6,17.4,3.5,32.9,0.7,50.8l-0.8,4.8l-4-0.6L369.5,192.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M407.6,195.2c4.2-17.1,6.1-32.5,2.4-49.7c4.3,17,5.7,32.7,1.5,50.5l-1.3,4.7l-3.9-0.9L407.6,195.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M444.8,200.7c2.8-16.4,4.1-30.8,0.7-47.1c4,16,6,30.7,3.3,47.6l-0.9,4.5l-3.9-0.6L444.8,200.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M471.7,206c3.7-15.9,6.6-29.8,5.1-45.9c2,15.9,2.5,30.2-1.2,46.6l-1.1,4.3l-3.9-0.8L471.7,206z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M311.1,58.4c-0.4,1.6-1.4,2.8-2.4,2.7s-1.4-1.6-1-3.2s1.4-2.8,2.4-2.7C311,55.3,311.5,56.7,311.1,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M301.7,82.7c-0.3,1.3-1.2,2.3-1.9,2.2c-0.8-0.1-1.2-1.3-0.9-2.7s1.2-2.3,1.9-2.2 C301.6,80.2,302,81.4,301.7,82.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M265.4,112.2c-0.3,1.3-1.2,2.3-1.9,2.2c-0.8-0.1-1.2-1.3-0.9-2.7c0.3-1.3,1.2-2.3,1.9-2.2 C265.3,109.6,265.7,110.8,265.4,112.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M259.8,190.5c0,1.4-0.6,2.5-1.4,2.5s-1.5-1.1-1.5-2.4c0-1.4,0.6-2.5,1.4-2.5 C259.1,188,259.8,189.1,259.8,190.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M288.2,149.6c0.1,1.6-0.7,3-1.6,3s-1.8-1.3-1.8-2.9c-0.1-1.6,0.7-3,1.6-3 C287.4,146.7,288.2,148,288.2,149.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M285.6,188c0.4,1.6,0,3-1,3.2c-0.9,0.2-2-1-2.4-2.6s0-3,1-3.2C284.1,185.2,285.2,186.4,285.6,188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M316.6,169.6c0.3,1.6-0.3,3-1.2,3.1c-0.9,0.1-1.9-1.1-2.2-2.7c-0.3-1.6,0.3-3,1.2-3.1 C315.3,166.8,316.3,168,316.6,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M327.3,143.7c0,1.6-0.8,2.9-1.8,2.9c-0.9,0-1.7-1.3-1.6-3c0-1.6,0.8-2.9,1.8-2.9 C326.6,140.7,327.3,142.1,327.3,143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M354.2,147.2c0,1.6-0.8,2.9-1.8,2.9c-0.9,0-1.7-1.3-1.6-3c0-1.6,0.8-2.9,1.8-2.9 C353.5,144.2,354.3,145.6,354.2,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M349.9,184.6c0,1.6-0.8,2.9-1.8,2.9c-0.9,0-1.7-1.3-1.6-3c0-1.6,0.8-2.9,1.8-2.9 C349.2,181.6,349.9,182.9,349.9,184.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M390.4,158.9c0,1.6-0.8,2.9-1.8,2.9c-0.9,0-1.7-1.3-1.6-3c0-1.6,0.8-2.9,1.8-2.9 C389.7,155.9,390.5,157.3,390.4,158.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M394.8,187.2c-0.3,1.6-1.2,2.8-2.2,2.7c-0.9-0.1-1.5-1.5-1.2-3.1s1.2-2.8,2.2-2.7 C394.5,184.2,395,185.6,394.8,187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M433.9,181.2c-0.3,1.6-1.2,2.8-2.2,2.7c-0.9-0.1-1.5-1.5-1.2-3.1s1.2-2.8,2.2-2.7 C433.6,178.2,434.1,179.6,433.9,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M460.8,164.1c0,1.6-0.7,2.9-1.7,2.9c-0.9,0-1.7-1.3-1.7-2.9c0-1.6,0.7-2.9,1.7-2.9 C460,161.2,460.8,162.5,460.8,164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M463.1,196.4c-0.1,1.6-1,2.9-1.9,2.8c-0.9-0.1-1.6-1.4-1.5-3s1-2.9,1.9-2.8 C462.6,193.4,463.3,194.7,463.1,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M488.5,167.4c0,2-1,3.7-2.2,3.6c-1.2,0-2.1-1.7-2.1-3.7s1-3.7,2.2-3.6 C487.6,163.7,488.5,165.3,488.5,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M294.1,111.6c-0.2,1.4-1.1,2.5-1.9,2.4s-1.3-1.3-1.1-2.7c0.2-1.4,1.1-2.5,1.9-2.4 S294.3,110.2,294.1,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M275.1,74.3c-0.8,1.7-2.2,2.8-3.2,2.5s-1.1-2-0.4-3.7c0.8-1.7,2.2-2.8,3.2-2.5 C275.7,71,275.8,72.6,275.1,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M246.8,111.1c-0.5,1.8-1.7,3-2.8,2.8c-1-0.2-1.5-1.8-1-3.6c0.5-1.8,1.7-3,2.8-2.8 C246.8,107.8,247.2,109.4,246.8,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M239.1,133.9c-0.1,1.8-1,3.3-2,3.3c-1.1,0-1.9-1.5-1.8-3.3c0.1-1.8,1-3.3,2-3.3 C238.3,130.6,239.1,132.1,239.1,133.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M229.4,182.3c-0.1,1.8-1,3.3-2,3.3c-1.1,0-1.9-1.5-1.8-3.3c0.1-1.8,1-3.3,2-3.3 C228.7,178.9,229.5,180.4,229.4,182.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M253.8,165c-0.1,1.6-0.9,3-1.8,2.9c-1,0-1.7-1.4-1.6-3c0.1-1.6,0.9-3,1.8-2.9 C253.1,162,253.8,163.3,253.8,165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M230.1,205.8c0.3,1.4-0.1,2.7-0.9,2.8c-0.8,0.1-1.7-0.9-2-2.3c-0.3-1.4,0.1-2.7,0.9-2.8 S229.8,204.4,230.1,205.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M332.7,73.4c0,1.4-0.7,2.6-1.5,2.6c-0.9,0-1.6-1.1-1.6-2.6c0-1.4,0.7-2.6,1.5-2.6 C332,70.8,332.7,71.9,332.7,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M330.6,111.6c0,1.4-0.8,2.6-1.6,2.6c-0.9,0-1.5-1.2-1.5-2.6s0.7-2.6,1.6-2.6S330.7,110.2,330.6,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M365.8,71.6c0,1.4-0.8,2.6-1.6,2.6c-0.9,0-1.5-1.2-1.5-2.6s0.7-2.6,1.6-2.6 C365.1,69,365.8,70.1,365.8,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M368.9,93.5c0,1.4-0.7,2.6-1.6,2.6s-1.5-1.2-1.5-2.6s0.7-2.6,1.6-2.6C368.2,90.9,368.9,92.1,368.9,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M395.5,69.4c0.2,1.4-0.3,2.6-1.1,2.7c-0.8,0.1-1.7-1-1.9-2.4c-0.2-1.4,0.3-2.6,1.1-2.7 C394.4,66.9,395.3,68,395.5,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M403.8,113.1c0.2,1.4-0.3,2.6-1.1,2.7c-0.8,0.1-1.7-1-1.9-2.4c-0.2-1.4,0.3-2.6,1.1-2.7 S403.6,111.7,403.8,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M431,87.1c0.4,1.4,0.1,2.7-0.7,2.9c-0.8,0.2-1.9-0.8-2.3-2.1c-0.4-1.4-0.1-2.7,0.7-2.9 C429.5,84.8,430.5,85.8,431,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M447,120.9c0.4,1.4,0.1,2.7-0.8,2.8c-0.8,0.2-1.8-0.8-2.2-2.2c-0.4-1.4-0.1-2.7,0.8-2.8 C445.6,118.5,446.6,119.5,447,120.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M467.7,99.5c0.4,1.4,0.1,2.7-0.8,2.8c-0.8,0.2-1.8-0.8-2.2-2.2c-0.4-1.4-0.1-2.7,0.8-2.8 C466.3,97.1,467.3,98.1,467.7,99.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat1WHair2);
export default __webpack_public_path__ + "static/media/m-hat1_w-hair2.ef20ed5d824f2651f176e47ca5131de9.svg";
export { ForwardRef as ReactComponent };